import { toTimestamp } from '../utils/addWebSocketToReplication'
import { toISOString, toISOStringOrNull } from '../utils/pushSafetyUtils'
import { createReplication } from './createReplication'
import type { CycleCollection } from '../index'

export const setupCycleReplication = (
  collection: CycleCollection,
  envId: string,
) =>
  createReplication({
    entityName: 'cycles',
    displayName: 'Cycle',
    collection,
    envId,
    mapFromServer: (doc) => ({
      id: doc.id,
      envId: doc.envId,
      projectId: doc.projectId,
      name: doc.name,
      number: doc.number,
      startDate: toTimestamp(doc.startDate) ?? 0,
      endDate: toTimestamp(doc.endDate) ?? 0,
      status: doc.status ?? 'draft',
      description: doc.description || null,
      completedOn: doc.completedOn ? toTimestamp(doc.completedOn) : null,
      completedBy: doc.completedBy || null,
      isDeleted: doc.isDeleted || false,
      createdOn: toTimestamp(doc.createdOn) ?? new Date(doc.createdOn).getTime(),
      createdBy: doc.createdBy,
      updatedOn: toTimestamp(doc.updatedOn) ?? new Date(doc.updatedOn).getTime(),
      updatedBy: doc.updatedBy,
      deletedOn: doc.deletedOn ? (toTimestamp(doc.deletedOn) ?? new Date(doc.deletedOn).getTime()) : null,
      deletedBy: doc.deletedBy,
    }),
    mapToServer: (state, envId) => ({
      id: state.id,
      envId,
      projectId: state.projectId,
      name: state.name,
      number: state.number,
      startDate: toISOString(state.startDate),
      endDate: toISOString(state.endDate),
      status: state.status,
      description: state.description || null,
      completedOn: toISOStringOrNull(state.completedOn),
      completedBy: state.completedBy || null,
      isDeleted: state.isDeleted,
      createdOn: toISOString(state.createdOn),
      createdBy: state.createdBy,
      updatedOn: toISOString(state.updatedOn),
      updatedBy: state.updatedBy,
      deletedOn: toISOStringOrNull(state.deletedOn),
      deletedBy: state.deletedBy,
    }),
  })
